import { ImageCircle, type ImageCircleStyling } from '$components'
import { Text } from '$components'
import { LinkIcon } from '$icons'
import { Link } from 'react-router-dom'

export type EntityLinkProps = {
  children: string,
  path: string,
  image?: string,
  iconSize?: ImageCircleStyling['size']
}

export function EntityLink({ children, path, image, iconSize = 'sm' }: EntityLinkProps) {

  return (
    <Link
      to={path}
      className="flex items-center gap-stack-tight group w-fit"
    >
      { image && (
        <div className="flex items-center gap-stack-tight">
          <ImageCircle
            image={image!}
            size={iconSize}
          />
        </div>
      )}

      <Text
        type="s"
        className="group-hover:text-fg"
      >
        { children }
      </Text>

      <LinkIcon className="size-4 text-fg-subtle group-hover:text-fg" />
    </Link>
  )
}
